/**************************************************
 * Nombre:       Nosotros_Aportes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Nosotros_Aportes = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: theme.palette.primary.main}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontSize: 16, fontWeight: 600}}>NOSOTROS</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'center', mb: 4, mt: -2}}>
                            <Typography sx={{fontSize: sCell ? 32 : 40, fontWeight: 600, lineHeight: 1, textAlign: 'center'}}>
                                Tradición Maestra y Visión Global
                                <span style={{fontWeight: 800}}>El Corazón de Generación Mezcal</span></Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 20, fontWeight: 600}}>Reyna Aquino: El Alma y el Rigor
                                    Artesanal</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                                <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                                    Reyna aporta a Generación Mezcal la esencia pura de Oaxaca y la custodia de un
                                    legado familiar inquebrantable. Como referente de la industria, su mayor
                                    contribución es el rigor en el origen: ella supervisa personalmente cada etapa del
                                    proceso, desde la selección del maguey en el campo hasta la destilación final.
                                    <br/>
                                    <br/>
                                    Su aporte asegura que la tienda no solo venda un producto, sino una pieza de
                                    historia líquida, garantizando que cada botella cumpla con los más altos estándares
                                    de autenticidad y honre la memoria de sus raíces con una excelencia artesanal
                                    impecable.
                                </Typography>
                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 20, fontWeight: 600}}>Reyna Aquino: El Alma y el Rigor
                                    Artesanal</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                                <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                                    Andrés aporta la estructura necesaria para transformar una tradición local en una
                                    potencia global. Su enfoque se centra en la profesionalización y escalabilidad de la
                                    marca, integrando tecnología de vanguardia y sistemas de trazabilidad que garantizan
                                    transparencia total al consumidor.
                                    <br/>
                                    <br/>
                                    Con su experiencia en inteligencia de mercado y logística internacional, Andrés
                                    asegura que Generación Mezcal opere con una eficiencia de clase mundial, permitiendo
                                    que el espíritu oaxaqueño llegue a cualquier destino con puntualidad, estrategia y
                                    un modelo de negocio sólido.
                                </Typography>
                            </Grid>


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Aportes

